import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface UpdateIntegrationOnPulverizationPayload {
  organization?: string | null
  layers: string[]
}

export async function updateIntegrationOnPulverization(
  culture: string,
  demandId: string,
  integrationType: 'john-deere',
  payload: UpdateIntegrationOnPulverizationPayload,
) {
  const { data } = await companiesApi.put(
    apiRoutes.updateIntegrationOnPulverization(
      culture,
      demandId,
      integrationType,
    ),
    payload,
  )

  return data
}
